module.exports = __webpack_public_path__ + "img/sm3.7a7cb6ed.png";